export default class Tag {
    constructor() {
        this.id = "";
        this.name = "";
        this.color = "";
        this.module = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
        this.color = data.color;
    }
}